import { render } from "./userDel.vue?vue&type=template&id=238c31c6"
import script from "./userDel.vue?vue&type=script&lang=js"
export * from "./userDel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__